import React from "react";
import styled from "styled-components";
import { useIntl } from "react-intl";
import { teamsWizardMessages } from "../messages";

type SummaryProps = {
  channelName: string;
  chanelDesc: string;
  accountName: string;
  teamToNotify: string;
  channelToNotify: string;
};

export const Summary = ({
  channelName,
  chanelDesc,
  accountName,
  teamToNotify,
  channelToNotify,
}: SummaryProps) => {
  const intl = useIntl();

  return (
    <>
      <ListWrapper>
        <Text>
          <b>{intl.formatMessage(teamsWizardMessages.channelName)}:</b> {channelName}
        </Text>
        <Text>
          <b>{intl.formatMessage(teamsWizardMessages.description)}:</b> {chanelDesc}
        </Text>
      </ListWrapper>
      <ListWrapper>
        <Text>
          <b>{intl.formatMessage(teamsWizardMessages.userAccount)}:</b> {accountName}
        </Text>
      </ListWrapper>
      <ListWrapper>
        <Text>
          <b>{intl.formatMessage(teamsWizardMessages.mSTeamsSender)}:</b> {accountName}
        </Text>
        <Text>
          <b>{intl.formatMessage(teamsWizardMessages.teamToNotify)}:</b> {teamToNotify}
        </Text>
        <Text>
          <b>{intl.formatMessage(teamsWizardMessages.channelToNotify)}:</b> {channelToNotify}
        </Text>
      </ListWrapper>
    </>
  );
};

const Text = styled.p`
  margin: 0;
`;

const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 15px;
`;
